<template>
  <ListView
    modelName="PartneredUser"
    perm="system.menu_partnered_user"
    :items.sync="items"
    :params.sync="params"
    title="menu_partnered_user"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="partnered_user"
    :gridCaptions="['テナントID','テナント','ユーザーID','ユーザー']"
    :gridWidths="[250,250,250,250]"
    :exportQuery="exportQuery"
    class="cx_partnered_user"
    :comparer="(a,b)=>a.id == b.id"            
    tooltip="顧問先テナントの一覧です。"
    :deleteHandler="onDelete"
     @created="onCreated"
  >
    <!-- 明細項目の配置 -->
    <GridItem slot="grid0" slot-scope="{ item }"><span class="cx_link_item" @click="onClick(item.tenantId)"> {{ item.tenantId }}</span></GridItem>  
    <!-- <GridItem slot="grid0" slot-scope="{ item }">{{ item.tenantId }}</GridItem> -->
    <GridItem slot="grid1" slot-scope="{ item }">{{ item.tenantName}}</GridItem>
    <GridItem slot="grid2" slot-scope="{ item }">{{ item.userId }}</GridItem>
    <GridItem slot="grid3" slot-scope="{ item }">{{ item.userId | userGroup}}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }"><ListViewMenuBar :listView="listView" :edit="false" :copy="false"/></template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search  :listView="listView">
        <FilterBox title="テナントID" :value.sync="params.tenantId" placeholder="Enter ID" @click="handler" />
        <FilterBox title="テナント名称" :value.sync="params.tenantName" placeholder="Enter Name" @click="handler" />
        <FilterBox title="ユーザーID" :value.sync="params.userId" placeholder="Enter ID" @click="handler" />
        <FilterBox title="ユーザー名称" :value.sync="params.userName" placeholder="Enter Name" @click="handler" />
      </Search>
    </template>
    <!-- エディタの配置 -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報']" :tabTooltips="[null]">
        <template slot="tab0" slot-scope="{ editor, item }">
          <EditPanel>
            <template slot="left">
              <AutoComplete title="テナント" :editor="editor" :enabled="listView.isInsertMode" :value.sync="item.tenantId" list="partneredTenantList"  :required="true" tooltip="顧問先のテナントです。顧問先テナントで表示されているテナントから選択できます。" />
              <AutoComplete title="ユーザー" :editor="editor" :enabled="listView.isInsertMode" :value.sync="item.userId" list="user" :required="true" tooltip="顧問先にアクセスできるユーザーです。" />
            </template>
          </EditPanel>
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class GroupView extends Vue {
  public items: Common.PartneredUser[] = new Array();
  public params: Common.PartneredUserQuery = new Common.PartneredUserQuery();
  public exportQuery = new Common.ExportQuery('顧問先アクセス管理', this.params);

  public sortOptions: any = [
    { value: 'tenantid', text: 'テナントID' },
    { value: 'tenantname', text: 'テナント' },
    { value: 'userid', text: 'ユーザーID' },
    { value: 'username', text: 'ユーザー' },
  ];


  public created(){
    this.$api.formatter.ensureListLoaded('partneredTenantList');
  }  
  public onCreated(listView:any){
    listView.onExec = this.onExec;
  }
  // 追加時の動作
  public async onExec(item: any) {
    
    var query = new Common.PartneredUserCreateQuery();
    query.tenantId = item.tenantId;
    query.userId = item.userId;
    return this.$api.execute(query).then(res=>{
    let listView = (this.$refs.mainList as Components.ListView);
    listView.isInsertMode = false;
    listView.isEditting = false;
    if (listView.fullSizeEditor == false) {
      listView.sideEditor.setState(Common.editorStates.Read);
    } else {
      //フルサイズエディタの表示
      listView.editor.setState(Common.editorStates.Read);
    }
      listView.reload();
      return true;
    }).catch(()=>{return false;});
  }
  public async onDelete(){
    var selectedItems =  (this.$refs.mainList as Components.ListView).selectedItems;
    return this.$api.modal.showDialog('確認メッセージ', selectedItems.length + '件のデータを本当に削除してよろしいですか?', false)
        .then(() => {
          this.$api.startWaitCusor();
          return this.$api.execute(new Common.PartneredUserDeleteQuery(selectedItems)).finally(()=>this.$api.closeWaitCursor());
        });
  }
  //テナントに遷移
  public onClick(tenantId:string){        
    if (this.$api.enviromentFlag == Common.enviromentFlags.production) window.open(String.format("https://{0}.s-flow.net",tenantId), '_blank');       
    else window.open(String.format("https://{0}.s-flow-stage.net",tenantId), '_blank');                     
  }
}
</script>